import { $black } from './commonColors';

const primaryMain = '#CC0000';
const primaryMainOpacity = 'rgba(204, 0, 0, 0.9)';
const secondaryMain = $black;
const secondaryMainOpacity = 'rgba(0, 0, 0, 0.5)';
const secondaryLight = $black;
const tertiaryMain = '#660000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
